// extracted by mini-css-extract-plugin
export default {"ResizeHandleOuter":"ResizeHandle_ResizeHandleOuter__uob6h","ResizeHandleInner":"ResizeHandle_ResizeHandleInner__ega35","ResizeHandleIcon":"ResizeHandle_ResizeHandleIcon__KnyZK"};